/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerResetPasswordResponse } from "./MemberManagerResetPasswordResponse";

export type MemberManagerResetPasswordResponseApiRespoonse = {
  data?: MemberManagerResetPasswordResponse;
  status?: MemberManagerResetPasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerResetPasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
